module.exports = __webpack_public_path__ + "static/media/main.96bc736d.jpg";